/* eslint-disable react/prop-types */
import { useRef } from "react"
import Icon from "components/planning_center_icon"
import { useKeyListener } from "components/key_listener"

const Form = ({
  form: { id, key, name, remoteURL, fileURL, formRequiredFor = [], archived, closed, externalForm }
}) => {
  const rowRef = useRef(null)
  const formRef = useRef(null)

  useKeyListener({
    elref: rowRef,
    except: [formRef]
  })

  return (
    <tr
      style={{ verticalAlign: "top" }}
      key={key}
      className="row__clickable"
      role="button"
      tabIndex="0"
      data-link={`/forms/${id}/edit`}
      ref={rowRef}
    >
      <td>
        {name}
        {archived && <span className="ml-1 badge">Archived</span>}
        {closed && <span className="ml-1 badge">Closed</span>}
      </td>
      <td>
        {remoteURL && !externalForm && "People form"}
        {remoteURL && externalForm && "External form"}
        {fileURL && "PDF"}
      </td>
      <td>
        {formRequiredFor &&
          formRequiredFor.map((req, index) => {
            return <div key={index}>{req}</div>
          })}
      </td>
      <td className="p-0">
        <a
          target="_blank"
          rel="noreferrer"
          href={fileURL || remoteURL}
          onClick={e => {
            e.stopPropagation()
          }}
          aria-label="open form in a new window"
          ref={formRef}
          css={{
            display: "block",
            padding: "0.75rem 1rem"
          }}
        >
          <Icon symbol="general#new-window" />
        </a>
      </td>
    </tr>
  )
}

export default Form
